export default defineNuxtRouteMiddleware(async (to, from) => {
  const { $gaApp } = useNuxtApp()

  // рефреш для обновления на новую версию прилы
  const hasForceUpdate = $gaApp.stores.app.main.hasForceUpdate

  if (hasForceUpdate) {
    window.location.assign(to.fullPath)

    return abortNavigation()
  }

  if (to.path !== from.path && $gaApp.stores.main.user.isAuthorized) {
    try {
      $gaApp.services.main.user.getUser(true)
    } catch (error) {
      $gaApp.services.app.rejection.log({
        name: 'main:get-user-while-route-changing',
        message:
          'Ошибка обновления данных пользователя при переходе между страницами',
        errorData: error,
      })
    }
  }
})
